(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('animated-product-hero')) {
    customElements.define(
      'animated-product-hero',
      class AnimatedProductHero extends HTMLElement {
        connectedCallback() {
          if (this.dataset.motionBound === 'true') return;
          this.dataset.motionBound = 'true';

          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (reducedMotion || !('IntersectionObserver' in window)) {
            this.classList.add('is-visible');
            return;
          }

          this.classList.add('motion-initialized');

          const repeatAnimation = this.dataset.repeatAnimation === 'true';
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.classList.add('is-visible');

                  if (!repeatAnimation) {
                    this.observer.unobserve(this);
                  }
                } else if (repeatAnimation) {
                  this.classList.remove('is-visible');
                }
              });
            },
            {
              threshold: 0.2,
              rootMargin: '0px 0px -8% 0px'
            }
          );

          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-animated"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const API_KEY = 'SkunkworksHeroMotion';
    const SELECTOR = '[data-hero-motion="true"]';

    if (window[API_KEY]) {
      window[API_KEY].init(document);
      return;
    }

    const observers = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setItemDelays = (hero) => {
      const content = hero.querySelector('.hero__content-wrapper');
      if (!content) return;

      const styles = window.getComputedStyle(hero);
      const baseDelay = Number.parseFloat(styles.getPropertyValue('--hero-motion-delay')) || 0;
      const stagger = Number.parseFloat(styles.getPropertyValue('--hero-motion-stagger')) || 0;

      Array.from(content.children).forEach((element, index) => {
        element.style.setProperty('--hero-motion-item-delay', `${baseDelay + index * stagger}ms`);
      });
    };

    const reveal = (hero) => {
      window.requestAnimationFrame(() => hero.classList.add('is-motion-visible'));
    };

    const hide = (hero) => {
      hero.classList.remove('is-motion-visible');
    };

    const initHero = (hero) => {
      if (!(hero instanceof HTMLElement) || hero.dataset.motionBound === 'true') return;

      hero.dataset.motionBound = 'true';
      setItemDelays(hero);
      hero.dataset.motionInitialized = 'true';

      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        reveal(hero);
        return;
      }

      const playOnce = hero.dataset.motionOnce !== 'false';
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal(hero);
              if (playOnce) observer.unobserve(hero);
            } else if (!playOnce) {
              hide(hero);
            }
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px',
        }
      );

      observers.set(hero, observer);
      observer.observe(hero);
    };

    const init = (scope = document) => {
      if (scope instanceof Element && scope.matches(SELECTOR)) initHero(scope);
      scope.querySelectorAll?.(SELECTOR).forEach(initHero);
    };

    const destroyHero = (hero) => {
      const observer = observers.get(hero);
      if (observer) observer.disconnect();
      observers.delete(hero);
    };

    const destroy = (scope) => {
      if (scope instanceof Element && scope.matches(SELECTOR)) destroyHero(scope);
      scope.querySelectorAll?.(SELECTOR).forEach(destroyHero);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const hero = event.target.querySelector?.(SELECTOR);
      if (hero) reveal(hero);
    });

    window[API_KEY] = { init, destroy };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const API_KEY = 'SkunkworksHeroMotion';
    const SELECTOR = '[data-hero-motion="true"]';

    if (window[API_KEY]) {
      window[API_KEY].init(document);
      return;
    }

    const observers = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setItemDelays = (hero) => {
      const content = hero.querySelector('.hero__content-wrapper');
      if (!content) return;

      const styles = window.getComputedStyle(hero);
      const baseDelay = Number.parseFloat(styles.getPropertyValue('--hero-motion-delay')) || 0;
      const stagger = Number.parseFloat(styles.getPropertyValue('--hero-motion-stagger')) || 0;

      Array.from(content.children).forEach((element, index) => {
        element.style.setProperty('--hero-motion-item-delay', `${baseDelay + index * stagger}ms`);
      });
    };

    const reveal = (hero) => {
      window.requestAnimationFrame(() => hero.classList.add('is-motion-visible'));
    };

    const hide = (hero) => {
      hero.classList.remove('is-motion-visible');
    };

    const initHero = (hero) => {
      if (!(hero instanceof HTMLElement) || hero.dataset.motionBound === 'true') return;

      hero.dataset.motionBound = 'true';
      setItemDelays(hero);
      hero.dataset.motionInitialized = 'true';

      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        reveal(hero);
        return;
      }

      const playOnce = hero.dataset.motionOnce !== 'false';
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal(hero);
              if (playOnce) observer.unobserve(hero);
            } else if (!playOnce) {
              hide(hero);
            }
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px',
        }
      );

      observers.set(hero, observer);
      observer.observe(hero);
    };

    const init = (scope = document) => {
      if (scope instanceof Element && scope.matches(SELECTOR)) initHero(scope);
      scope.querySelectorAll?.(SELECTOR).forEach(initHero);
    };

    const destroyHero = (hero) => {
      const observer = observers.get(hero);
      if (observer) observer.disconnect();
      observers.delete(hero);
    };

    const destroy = (scope) => {
      if (scope instanceof Element && scope.matches(SELECTOR)) destroyHero(scope);
      scope.querySelectorAll?.(SELECTOR).forEach(destroyHero);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const hero = event.target.querySelector?.(SELECTOR);
      if (hero) reveal(hero);
    });

    window[API_KEY] = { init, destroy };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
